import { Container, Grid, Stack } from '@mui/material';
import {
	OrgProfileOrgConnectionsBar,
	UserProfileOrgConnectionsBar,
} from 'components/pages/network/org/OrgConnections/orgConnectionsBarWrappers';
import { useOrgId } from 'components/pages/org/outlet';
import { OrgProfileHeader } from 'components/pages/org/profile/header/header';
import { ProfileAdministration } from 'components/pages/user/profile/admin';
import { ProfileHeader } from 'components/pages/user/profile/header/header';
import { LicensingInformation } from 'components/pages/user/profile/licensing/licensing-info';
import { PageContent, PageTitle } from 'components/ui/page';

export const UserProfilePage = (props: { userId: string }) => {
	return (
		<>
			<PageTitle title="Profile" />
			<PageContent>
				<Container maxWidth="xl">
					<Grid container spacing={3}>
						<Grid
							item
							xl={1}
							sx={{
								display: {
									xs: 'none',
									xl: 'block',
								},
							}}
						/>
						<Grid item xs={12} lg={9} xl={8}>
							<Stack
								spacing={{ xs: 2, md: 3 }}
								margin={{ xs: '-12px -28px', md: 'unset' }}>
								<ProfileHeader userId={props.userId} />
								<UserProfileOrgConnectionsBar userId={props.userId} />
								<LicensingInformation userId={props.userId} />
							</Stack>
						</Grid>
						<Grid
							item
							lg={3}
							xl={3}
							sx={{
								display: {
									lg: 'block',
								},
							}}>
							<ProfileAdministration />
						</Grid>
					</Grid>
				</Container>
			</PageContent>
		</>
	);
};

/**
 * Org profile screen.  Layout for all the cards on the profile of orgs.
 */
export const OrgProfilePage = () => {
	const orgId = useOrgId();

	return (
		<>
			<PageTitle title="Profile" />
			<PageContent>
				<Container maxWidth="xl">
					<Grid container spacing={3}>
						<Grid
							item
							xl={1}
							sx={{
								display: {
									xs: 'none',
									xl: 'block',
								},
							}}
						/>
						<Grid item xs={12} lg={9} xl={8}>
							<Stack
								spacing={{ xs: 2, md: 3 }}
								margin={{ xs: '-12px -28px', md: 'unset' }}>
								<OrgProfileHeader orgId={orgId} />
								<OrgProfileOrgConnectionsBar orgId={orgId} />
							</Stack>
						</Grid>
						<Grid
							item
							lg={3}
							xl={3}
							sx={{
								display: {
									xs: 'none',
									lg: 'block',
								},
							}}></Grid>
					</Grid>
				</Container>
			</PageContent>
		</>
	);
};
